import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const DascasDashboardPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dascas-dashboard-page" */ '../../pages/dascas-dashboard'
    ),
);

const dascasDashboardRouter = (
  <Route path="dascas-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dascas-dashboard"
            component={<DascasDashboardPageComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dascasDashboardRouter;
